module.exports = __webpack_public_path__ + "static/key_shortcuts-fab324b85db293aa7785b06051274335.png";